// Auto-refactored from translations.js on 2026-08-19
// Locale: cs

const cs = {
  wieMoeglich: { question: 'Jak je to možné?', answer: 'Přehodnotili jsme hodnotový řetězec.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Cesta STIG ROCK',
    fazit: 'Zkrácený dodavatelský řetězec eliminuje největší nákladové položky.',
    fazitBigPre: 'To umožňuje slevu až',
    fazitBigValue: '80%',
    steps: [ 'Důl', 'Brusírna', 'Certifikace', 'Koncový zákazník' ]
  },
  nav: { language: 'Jazyk', contact: 'Kontakt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Jedinečná příležitost',
    subtitle: 'Budování majetku s orientací na budoucnost.',
    description: 'STIG ROCK je mezinárodní platforma, která lidem nabízí přístup k přírodním diamantům, udržitelnému budování majetku a jedinečné komunitě.',
    scroll: 'Scrollovat a objevovat'
  },
  disclaimer: {
    overline: 'Právní upozornění',
    title: 'Disclaimer',
    paragraphs: [
      'Tato prezentace slouží pouze pro informační účely a nepředstavuje finanční, investiční ani daňové poradenství.',
      'STIG ROCK není finančním produktem, ale vztahuje se na přírodní diamanty jako věcné hodnoty.',
      'Na vývoj hodnoty, zisky nebo výnosy není poskytována žádná záruka. Minulý vývoj není indikací budoucích výsledků.',
      'Veškeré uvedené výpočty v souvislosti s provizemi jsou pouze příkladem a rovněž nepředstavují žádnou záruku.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'VYBUDOVÁNO', 'NA STRUKTUŘE' ],
    body: 'STIG Group je mezinárodní koncern vybudovaný na jasnosti, odpovědnosti a dlouhodobé hodnotě. Každá značka, každý projekt a každé Partnerství sleduje jediný standard — bez zkratek, bez výjimek.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'VYBUDOVÁNO', 'NA STRUKTUŘE' ],
        body: 'STIG Group je mezinárodní koncern vybudovaný na jasnosti, odpovědnosti a dlouhodobé hodnotě. Každá značka, každý projekt a každé Partnerství sleduje jediný standard — bez zkratek, bez výjimek.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'SVĚT', 'EXKLUZIVNÍCH DIAMANTŮ' ],
        body: 'STIG ROCK je moderní koncept STIG Group, který spojuje vysoce kvalitní diamanty certifikované GIA s transparentními strukturami a exkluzivním zákaznickým zážitkem. Jasné plány řešení, profesionální realizace a mezinárodní zaměření.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'MEZINÁRODNÍ', 'OBCHOD S DIAMANTY' ],
        body: 'STIG International je součástí STIG Group a specializuje se na mezinárodní obchod s diamanty certifikovanými GIA. Zaměření na kvalitu, důvěru a moderní obchodní struktury s globálními Partnerstvími.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ODPOVĚDNOST', 'JIŽ OD DOLU' ],
        body: 'Ethical Mines představuje odpovědnou těžbu, sledovatelný původ a bezkonfliktní diamanty. Od dolu až na trh — kompletní dokumentace pro transparentnost, integritu a dlouhodobou odpovědnost v celém dodavatelském řetězci.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamanty',
    stigDrawback: 'Skutečný uchovatel hodnoty',
    overline: 'Možnosti',
    title: 'Možnosti budování majetku',
    subtitle: 'Srovnání tradičních cest.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex nebo krypto',
        drawback: 'vysoce spekulativní, nepředvídatelné, komplexní'
      },
      {
        tag: 'Akcie',
        name: 'Burzovní obchodování',
        drawback: 'riziko kolísání, potřebné znalosti, časová náročnost'
      },
      {
        tag: 'Krypto',
        name: 'Obchodování',
        drawback: 'volatilita, regulační riziko, bezpečnostní mezery'
      }
    ]
  },
  chance: {
    overline: 'Diamanty',
    title: 'Podceňovaná příležitost',
    body: 'Diamanty patří léta k nejstabilnějším formám investic s velkým potenciálem, přesto jej dosud využívalo jen málo lidí.',
    callout: 'S naší STIG ROCK poprvé otevíráme přístup k těmto výjimečným možnostem všem.'
  },
  wertentwicklung: {
    overline: 'Vývoj hodnoty 1995 — 2025',
    title: 'Příběh o hodnotě.',
    usd: 'Americký dolar',
    usdValue: '-49%',
    diamond: 'Diamanty',
    diamondValue: '+185%',
    note: 'Vývoj od 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Hlavní důvody',
    title: 'Šest důvodů pro diamanty',
    lead: 'Diamanty jsou reálné věcné hodnoty, které existují nezávisle na měnách a finančních systémech — a po staletí si uchovávají svou hodnotu.',
    items: [
      {
        n: '01',
        title: 'Stabilita hodnoty v krizi',
        body: 'Záruka věcné hodnoty. Nezávislost na měnách a finančních systémech.'
      },
      {
        n: '02',
        title: 'Maximální mobilita',
        body: 'Malé, snadno ukrytelné a transportovatelné.'
      },
      {
        n: '03',
        title: 'Diverzifikace a vzácnost',
        body: 'Nedostatek nabídky a přirozená limitace.'
      },
      { n: '04', title: 'Dlouhodobý růst', body: '+185% od roku 1995.' },
      {
        n: '05',
        title: 'Transparentnost a exkluzivita',
        body: '4 Cʼs jako záruka: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Rezerva královských rodů',
        body: 'I královské rody využívají diamanty jako majetkovou rezervu.'
      }
    ]
  },
  markt: {
    overline: 'Tržní objem',
    title: '99 — 108 Mrd. USD',
    sub: 'Objem obchodu v roce 2025',
    forecast: 'Prognóza do ~2032 / 2034: cca 140 – 168 Mrd. USD při mírném růstu (~4 – 5 % p.a.).',
    source: 'Zdroj: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Inovace',
    title: 'Inovace. Poprvé na světě.',
    body: 'STIG ROCK je první platformou na světě, která lidem umožňuje získat pasivní příjem na trhu s diamanty navíc k nárůstu jejich hodnoty.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Registrační č. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'O společnosti',
    titleLines: [ 'MEZINÁRODNÍ', 'STRUKTURA', 'JASNÁ VIZE' ],
    body: 'STIG ROCK byla založena s cílem učinit trh s diamanty transparentnějším, modernějším a více orientovaným na zákazníka — se zaměřením na důvěru, bezpečnost a dlouhodobou strukturu.'
  },
  sicherheit: {
    overline: 'Kvalita a bezpečnost',
    title: 'Gemological Institute of America',
    body: 'Certifikovaná expertíza pro vaše diamanty. GIA hodnotí každý kámen s nejvyšší precizností a dlouholetou zkušeností — spolehlivé znalecké posudky pro naši společnost i naše zákazníky.',
    transparency: 'Každý diamant splňuje nejvyšší standardy kvality a je kontrolován a certifikován renomovanými organizacemi. Každý kámen je jedinečný a obdrží individuální certifikát.',
    kimberley: 'Kimberley Process — pracujeme výhradně s bezkonfliktními diamanty.'
  },
  plaene: {
    overline: 'Solution Plány (SP)',
    title: 'Jedinečná produktová inovace',
    sub: 'Šest stupňovitých Solution Plánů — od $1K do $100K+, každý s rostoucí slevou za měsíc a po celou dobu trvání.',
    recommended: 'Oblíbené',
    oneYear: '1 rok',
    rowLabels: {
      delivery: 'Dodací lhůta',
      price: 'Cena produktu',
      carat: 'Karát',
      monthly: 'Sleva (měsíc)',
      totalDiscount: 'Sleva (celkem)',
      duration: 'Doba trvání'
    },
    headers: {
      plan: 'Plán',
      from: 'Od',
      carat: 'Karát',
      monthly: 'Sleva / měsíc',
      total: 'Sleva celkem',
      duration: 'Doba trvání'
    },
    duration: '1 rok',
    footnote: 'Všechny cenové údaje jsou bez záruky a závisí na kvalitě, poptávce a aktuálním vývoji trhu. Solution plány jsou možné i na 2 roky.'
  },
  plaeneVIP: {
    overline: 'Solution Plány + VIP balíček',
    title: 'S VIP balíčkem ještě vyšší sleva',
    sub: 'Celková sleva na plán – v kombinaci s VIP balíčkem získáte navíc +1% až +3%, což citelně zvyšuje celkovou slevu.',
    rowLabels: {
      delivery: 'Dodací lhůta',
      price: 'Cena produktu',
      carat: 'Karát',
      monthly: 'Sleva (měsíc)',
      totalDiscount: 'Sleva (celkem)',
      vip1: 'VIP balíček 1 (+1%)',
      vip2: 'VIP balíček 2 (+2%)',
      vip3: 'VIP balíček 3 (+3%)'
    },
    footnote: 'Všechny cenové údaje jsou bez záruky a závisí na kvalitě, poptávce a aktuálním vývoji trhu.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Vaše možnosti',
    sub: 'Po uplynutí vašeho Solution plánu můžete své diamanty buď prodat zpět nám, nebo si je nechat doručit domů.',
    options: [
      {
        key: 'deliver',
        title: 'Nechat si doručit',
        body: 'Diamanty (karát) za cenu vašeho DS-plánu*'
      },
      {
        key: 'sellToUs',
        title: 'Prodat nám',
        body: 'Své diamanty nám můžete prodat zpět za nákupní cenu, kterou jste zaplatili.'
      },
      {
        key: 'sellThirdParty',
        title: 'Prodat třetím stranám',
        body: 'Své diamanty můžete dále prodat třetím stranám.'
      }
    ],
    footnote: '*DS-plán znamená Solution plán.'
  },
  tradWeg: {
    overline: 'Tradiční obchod',
    title: 'Tradiční cesta',
    sub: 'Než se diamant dostane ke koncovému zákazníkovi, vznikají prostřednictvím zprostředkovatelského, velkoobchodního a maloobchodního prodeje značné obchodní marže oproti ceně surového diamantu z dolu.',
    steps: [
      { title: 'Důl', subtitle: 'Surové diamanty' },
      { title: 'Zprostředkovatel', subtitle: 'Nákup surových diamantů' },
      { title: 'Brusič', subtitle: 'Broušení na šperkové diamanty' },
      { title: 'Certifikace', subtitle: 'uznávanými instituty jako GIA' },
      { title: 'Diamantová burza', subtitle: 'Prodej velkoobchodu' },
      { title: 'Velkoobchod', subtitle: 'Prodej maloobchodu' },
      { title: 'Maloobchod', subtitle: 'např. klenotnictví' },
      { title: 'Koncoví zákazníci', subtitle: 'Nákup diamantů' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'Cesta STIG ROCK',
    sub: 'Tento cyklus přerušujeme tím, že kupujeme surové diamanty přímo z dolu, necháváme je brousit a certifikovat našimi Partnery. Díky tomu můžeme tyto obchodní marže předávat našim zákazníkům formou slevových připsání.',
    duration: '12 měsíců – doba trvání DS-plánu',
    centerBig: '04',
    centerCaption: 'Až 4 obchodní cykly během doby trvání DS-plánu',
    cycle: [
      { n: '1.', title: 'Nákup více surových diamantů', body: 'pro jeden DS-plán' },
      { n: '2.', title: 'Broušení a certifikace', body: 'našimi Partnery' },
      { n: '3.', title: 'Prodej koncovým zákazníkům', body: 'a velkoobchodníkům' },
      { n: '4.', title: 'Tento proces opakujeme', body: 'až 4× ročně' }
    ],
    steps: [
      { title: 'Důl', subtitle: 'Surové diamanty' },
      { title: 'Brusič', subtitle: 'našimi Partnery' },
      { title: 'Certifikace', subtitle: 'uznávanými instituty' },
      { title: 'Koncoví zákazníci', subtitle: 'Nákup a připsání slev' }
    ],
    footnote: '*DS-plán znamená Solution plán.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP balíčky',
    sub: 'Platí po dobu 12 měsíců na všechny vámi sjednané Solution plány. Podle VIP balíčku: +1% až +3% dodatečná sleva',
    cardKicker: 'navíc – na všechny',
    cardKicker2: 'Solution plány',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Ze slev se stávají úspory',
      body: 'Měsíční úspora místo měsíčního zatížení. Ze slev vznikají úspory – a ty platí přesně ty věci, za které jinak každý měsíc platíte z vlastní kapsy.',
      line1Label: 'DS-plán od',
      line1Value: '$5.000',
      line2Label: 'měs. sleva',
      line2Value: '3%',
      line3Label: 'VIP balíček 3',
      line3Value: '+3%',
      resultLabel: 'měs. úspory',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Jak je to možné?',
    title: 'Nově jsme promysleli hodnotový řetězec.',
    traditionalTitle: 'Tradiční cesta',
    traditionalSteps: [
      'Důl — surové diamanty',
      'Zprostředkovatel — nákup',
      'Brusič — brus',
      'Certifikace (GIA)',
      'Diamantová burza — velkoobchod',
      'Velkoobchod → maloobchod',
      'Klenotnictví → koncový zákazník'
    ],
    traditionalNote: 'Než se diamant dostane ke koncovému zákazníkovi, vznikají prostřednictvím zprostředkovatelského, velkoobchodního a maloobchodního prodeje značné obchodní marže.',
    stigTitle: 'Cesta STIG ROCK',
    stigSteps: [
      'Přímý nákup — surové diamanty z dolu',
      'Broušení a certifikace našimi Partnery',
      'Prodej koncovým zákazníkům a B2B klientům',
      'Až 4 obchodní cykly ročně'
    ],
    stigNote: 'Přerušujeme cyklus a předáváme obchodní marže jako slevová připsání našim zákazníkům — až 4 obchodní cykly během doby trvání DS-plánu.'
  },
  optionen: {
    overline: 'Vaše možnosti',
    title: 'Po uplynutí vašeho Solution plánu',
    items: [
      { title: 'Nechat si doručit', body: 'Diamanty (karát) za cenu vašeho DS-plánu.' },
      {
        title: 'Prodat nám',
        body: 'Zpětný prodej za nákupní cenu, kterou jste zaplatili.'
      },
      { title: 'Prodat třetím stranám', body: 'Prodej diamantů na volném trhu.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution plány — jedinečná produktová inovace',
    title: 'Jednoduchá cesta',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Registrace',
        body: 'Kontaktujte svého doporučitele a vytvořte si bezplatný účet!'
      },
      { n: '02', icon: 'cart', title: 'Nákup produktu', body: 'Již od $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Získávání slev',
        body: 'Získávejte měsíční připsání slev.'
      }
    ]
  },
  business: {
    overline: 'Druhy bonusů',
    title: 'Nejjednodušší a nejférovější cesta.',
    sub: 'Pět druhů bonusů — pro váš úspěšný rozvoj podnikání.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Do úrovně 3, od kariérního stupně Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Od Sapphire — do nekonečné hloubky.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Na Infinity Bonus – do úrovně 5 · BEZ kvalifikace.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pooly z celosvětového obratu.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Jednorázový bonus v diamantech (karát).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Tento bonus je vám vyplácen za každý nově sjednaný Solution plán až do 3. úrovně. S velmi nízkou kvalifikací si odemykáte jednotlivé úrovně.',
    total: 'Až 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'od začátku',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'od kariérního stupně Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'od kariérního stupně Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Od kariérního stupně Sapphire jste kvalifikováni pro náš Infinity Bonus plán. Získáváte 3% bonus. S každým novým kariérním stupněm přibývají další procenta. Pokud je Partner ve vašem týmu rovněž kvalifikován, získáváte rozdíl mezi stupni.',
    exampleTitle: 'Příklad',
    exampleRows: [
      { label: 'Jste Blue Diamond', value: '12%' },
      { label: 'Váš Partner je Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Váš Infinity Bonus', value: '9%' },
    totalNote: 'Celkem až 24% Infinity Bonus na všechny sjednané Solution plány ve vašem týmu — do nekonečné hloubky.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'S tímto bonusem profitujete z úspěchu svého týmu. Získáváte Matching Bonus ve výši 5% z Infinity Bonus vašich Partnerů — a to až do 5. úrovně vašeho týmu.',
    note: 'Na všechny výplaty Infinity Bonus ve vašem týmu – až do 5. úrovně. Od začátku – BEZ kvalifikace.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Celkem až',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% z celosvětového obratu plynou rovným dílem do 3 různých poolů. Dosažením určitých kariérních stupňů se kvalifikujete do každého jednotlivého poolu.',
    forever: 'Jednou dosaženo – NAVŽDY se podílíte!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'od Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'od Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'od Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Celkem',
    totalValue: '3%',
    totalSuffix: 'z celosvětového obratu'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Od kariérního stupně Diamond získáváte Rang Bonus. Ten je vyplácen v diamantech (karát). Jedná se o jednorázový bonus.',
    highlight: 'Diamanty (karát) v celkové hodnotě',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Kariérní stupně',
    title: 'Kariérní stupně',
    sub: 'Pro dosažení příslušných kariérních stupňů se započítává historický celkový obrat (HG). Ten musí být od stupně Sapphire rozdělen mezi více týmů. K dosažení Ruby nebo vyššího stupně potřebujete alespoň dva přímé Partnery se Solution plánem.',
    forever: 'Jednou dosaženo – NAVŽDY potvrzeno!',
    footnote: 'HV = Historický celkový obrat.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Odstartujte s námi',
    title: 'Správný čas je právě teď.',
    body: 'Tento obchodní model nastavuje nová měřítka a spojuje všechny faktory úspěchu pro dlouhodobě udržitelné a úspěšné podnikání. Zaregistrujte se ještě dnes, vyberte si svůj Solution plán a využijte tuto jedinečnou obchodní příležitost.',
    hint: 'Promluvte si s osobou, která vás na tuto prezentaci pozvala — má pro vás registrační odkaz.',
    formName: 'Jméno',
    formEmail: 'E-mail',
    formPhone: 'Telefon',
    formSubmit: 'Kontaktovat',
    success: 'Děkujeme — ozveme se vám diskrétně a osobně.',
    callCta: 'Zavolat',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Právní upozornění & Disclaimer',
    disclaimer: 'Tato prezentace slouží pouze pro informační účely a nepředstavuje finanční, investiční ani daňové poradenství. STIG ROCK není finančním produktem, ale vztahuje se na přírodní diamanty jako věcné hodnoty. Na vývoj hodnoty, zisky nebo výnosy není poskytována žádná záruka. Minulý vývoj není indikací budoucích výsledků. Veškeré uvedené výpočty v souvislosti s provizemi jsou pouze příkladem a rovněž nepředstavují žádnou záruku. Změny obsahu vyhrazeny — volný překlad (není oficiálním překladem).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Všechna práva vyhrazena.',
    version: 'Verze: DS-12-2025 V3'
  },
  misc: { next: 'Další sekce' }
};

export default cs;
